var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LangDropdown',{attrs:{"lang-code-key":"iso_code","id-key":"language_profile_id","options":_vm.options,"disabled":_vm.isLoading},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }